import styled from '@emotion/styled'

// We need to use this image in case when we use squared image from assets (Seal Jobs Design System) with build-in margin
// example: http://joxi.net/brRv04vCO9DNJr

export const SquaredImage = styled('img')`
  width: 128px;
  height: 128px;
`
